import type { Action } from 'svelte/action';

/**
 * Svelte action that scrolls an element to (0, 0) when it loads.
 */
export const scrollToTop: Action = (node) => {
  node.scrollTo(0, 0);
};
